import * as React from 'react';



import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

function InputText({ label }) {
  return <TextField
    label={label}
    size="small"
    style={{ width: "30rem" }}
    variant="outlined"
    sx={{
      width: '50rem',
      '& label': {
        color: 'lightgray',
      },
      '& label.Mui-focused': {
        color: 'gray',
      },
      '& .MuiInputBase-input': {
        color: 'lightgray',
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'lightgray',
        },
        '&:hover fieldset': {
          borderColor: 'gray',
        },
        '&.Mui-focused fieldset': {
          borderColor: 'gray',
        },
      },
      height: "40px",
      margin: "0 2rem"
    }}
  />
}

function SSHCard() {
  return (
    <div>
      <div style={{ border: "1px solid #222322", width: "50vw", padding: "1rem", margin: "0 auto" }}>
        <h3 className='main-color d-inline edit-icon'>
          SSH Connection
        </h3>
        <br />
        <Box
          component="form"
          sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
          noValidate
          autoComplete="off"
        >
          <InputText label="SSH Name" />
          <InputText label="SSH Username" />
          <InputText label="SSH Password / Private Key" />
          <InputText label="SSH IP Address" />
        </Box>

        <div style={{ margin: "1rem 0" }}></div>

        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          startIcon={<SaveAltIcon />}
          sx={{
            width: "20rem",
            backgroundColor: 'transparent',
            border: "1px solid gray",
            margin: "0 auto",
            color: 'white',
            '&:hover': {
              backgroundColor: 'transparent',
            },
            height: "40px",
            display: "flex",
            alignItems: "center"
          }}
        >
          Save SSH Configuration
        </Button>
      </div>
    </div>
  );
}

function FTPCard() {
  return (
    <div>
      <div style={{ border: "1px solid #222322", width: "50vw", padding: "1rem", margin: "0 auto" }}>
        <h3 className='main-color d-inline edit-icon'>
          FTP Connection
        </h3>
        <br />
        <Box
          component="form"
          sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
          noValidate
          autoComplete="off"
        >

          <InputText label={"FPT Name"} />
          <InputText label={"FTP Key"} />
          <InputText label={"FTP ID"} />
          <InputText label={"FTP Path"} />

        </Box>

        <div style={{ margin: "1rem 0" }}></div>

        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          startIcon={<SaveAltIcon />}
          sx={{
            width: "20rem",
            backgroundColor: 'transparent',
            margin: "0 auto",
            border: "1px solid gray",
            color: 'white',
            '&:hover': {
              backgroundColor: 'transparent',
            },
            height: "40px",
            display: "flex",
            alignItems: "center"
          }}
        >
          Save FTP Configuration
        </Button>
      </div>
    </div>
  );
}

export default function ImageSettings() {
  return <div className="content" style={{ marginTop: "1rem", textAlign: "center" }}>
    <SSHCard />
    <div style={{ margin: "5rem 0" }}></div>
    <FTPCard />
  </div>
}